import type { ReactNode } from "react";
import { useSessionBootstrap } from "@/features/auth/hooks/useSessionBootstrap";

export interface AuthBootstrapProps {
  children: ReactNode;
}

/**
 * Aktivizon rehidratimin e sesionit nje here ne krye te React tree.
 */
export const AuthBootstrap = ({ children }: AuthBootstrapProps): JSX.Element => {
  useSessionBootstrap();

  return <>{children}</>;
};
